/**
 * 预估到手价标识
 * @param {*} $finalPriceEle 显示到手机的父级元素
 * @param {*} productPrice 切换变体时的价格
 * @returns 
 */
function createFinalPrice($finalPriceEle, productPrice, carePrice = 0) {
    // 判断是否存在到手价dom节点元素
    if ($finalPriceEle.length == 0) return;
    // 获取当前商品类型，是主机或配件或耗材。主机：Craft Cutting & Embossing Tools；配件：Cutter Accessories；耗材：Art & Crafting Materials
    const productType = $finalPriceEle.attr('data-js-product-type') || '';
    // 商品阶梯折扣数据
    const productLadderDiscount = JSON.parse($finalPriceEle.attr('data-js-product-ladder-discount')||'[]') || [];
    // 查询当前商品类型的阶梯折扣数据
    const currentProductLadderDiscount = productLadderDiscount.filter(item => item.type === productType)[0];
    // 获取当前商品的tag
    const productTags = JSON.parse($finalPriceEle.attr('data-js-product-tags')||'[]') || [];        
    // 凡是tag有SMB Special的，则说明是特殊商品，不参与到手价
    const specialProduct = productTags.includes('SMB Special');
    
    // 判断是否存在阶梯折扣数据及是否开启了阶梯折扣数据，如果不存在或没开启或是特殊商品，就显示save，隐藏到手价
    if (!currentProductLadderDiscount || !currentProductLadderDiscount.enable || specialProduct) {
        // 产品页显示save
        $('.product-page-info__price-sale-details').show();
        return;
    }
    // 商品默认价格
    let price = $finalPriceEle.attr('data-js-product-variant-price');
    // 如果存在price入参，则说明是切换变体，那价格数据应该用最新的数据；否则，就用默认初始价格数据
    if (productPrice) {
        price = productPrice;
    }
    // 商品价格，把价格单位从分转为元，便于与阶梯折扣数据里的价格比较
    price = price / 100;
    // 判断当前商品是否是耗材，如果是，则：
    if (productType === window?._shopifyProductPageSetting?.productType?.material) {
        // 1、所有耗材打八折，也意味着除特殊品耗材外，其他所有耗材都显示到手价
        price = (price - carePrice) * 0.8 + carePrice;
        // 2、给耗材绑定悬浮框hover事件
        let timer = null;
        $finalPriceEle.hover(function () {
            clearTimeout(timer);
            $(this).find('.tip-popover-content').show();
        }, function () {
            timer = setTimeout(() => {
                $(this).find('.tip-popover-content').hide();
            }, 500);
        });
    } else {
        // 否则，重置除耗材详情页变体切换时的save和到手价为隐藏
        $finalPriceEle.hide();
        $('.product-page-info__price-sale-details').hide();
        if (window.innerWidth < 1025) { 
            $('.first-add-to-cart-description .estimated-final-price').css('margin-top', 10);
            $('.footbar-product-new .estimated-final-price').css('margin-top', 0);
             
        }
    }
    // 当前商品类型的阶梯折扣数据
    let ladderDiscount = currentProductLadderDiscount.discount;    
    // 默认折扣为0
    let discount = 0;
    if (Array.isArray(ladderDiscount) && ladderDiscount.length > 0) {
        // 把阶梯折扣数据按价格从小到大排序，以便定位当前商品位于的折扣区间
        ladderDiscount.sort((a, b) => {
            return a.price - b.price;
        });
        // 在阶梯折扣数据中找到商品价格所属区间
        ladderDiscount.forEach(item => {
            if (price >= item.price) {
                discount = item.discount;
            }
        });       
    }
    // 两种情况显示到手价：1、不论主机、配件还是耗材，只要折扣金额大于0，就显示到手价；2、耗材会一直显示到手价。
    if (discount > 0 || productType === window?._shopifyProductPageSetting?.productType?.material) {
        // 折扣后的到手价，转换为分，便于货币格式化
        const finalPrice = (price - discount) * 100;
        const money = Shopify.formatMoneyMarket(finalPrice, theme.moneyFormat);
        // 如果折扣金额大于0，则说明商品价格匹配到阶梯折扣，进行折扣计算，显示到手价，否则显示save
        $finalPriceEle.show().find('.final-price__value').text(money).attr('data-estimated-price', finalPrice);
        if ($('.footbar-product-new .show-in-mobile .footbar-product__price .price').find('span').length > 1) { 
            $('.footbar-product-new .footbar-product__price .price').find('span:last-child').hide();
        }
        if (window.innerWidth < 1025) { 
            if ($('.first-add-to-cart-description .product-page-info__price .price').find('span').length > 1) { 
                $('.first-add-to-cart-description .product-page-info__price .price').find('span:last-child').hide();
            }
            $('.first-add-to-cart-description .estimated-final-price').css('margin-top', 10);
            $('.footbar-product-new .estimated-final-price').css('margin-top', 0);
        }
    } else {
        // 产品页显示save
        $('.product-page-info__price-sale-details').show();
    }
}

(function($){
    $(function () {
        // 没有到手价dom，说明全局关闭了，那就要显示产品页显示save
        if ($(".estimated-final-price").length === 0) {
            $('.product-page-info__price-sale-details').show();
            return;
        }
        // 页面初始化时添加预估到手价，包括商详页和集合页初始化
        $(".estimated-final-price").each(function () {
            createFinalPrice($(this));
        });
    });
})(jQueryTheme);